/**
 * PAGINATION TOKENS
 * Source: 🎨 Figma — components-rentals export
 *
 * Custom additions are marked with "Custom" comments below.
 */

import { type SemanticTokens, SEMANTIC } from '../semantic.js';

export function createPaginationTokens(s: SemanticTokens) {
  return {
  // ──── Figma tokens ────

  bgDefault: s.surface.ground,               // --pagination-bg-default: var(--surface-ground)
  bgHover: s.surface.raised,                 // --pagination-bg-hover: var(--surface-raised)
  bgPressed: s.interactive.secondary.subtleHover, // --pagination-bg-pressed: var(--color-rentsody-100)
  bgActive: s.surface.ground,                // --pagination-bg-active: var(--surface-ground)
  bgDisabled: s.surface.disabled,            // --pagination-bg-disabled: var(--color-neutral-200)
  fgDefault: s.text.secondary,               // --pagination-fg-default: var(--text-secondary)
  fgHover: s.text.secondary,                 // --pagination-fg-hover: var(--text-secondary)
  fgActive: s.text.onColor,                  // --pagination-fg-active: var(--text-on-color)
  fgDisabled: s.text.onColor,                // --pagination-fg-disabled: var(--text-on-color)

  // ──── Custom tokens (not in Figma) ────

  shadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)', // --pagination-shadow
  base: {
    fontWeight: s.typography.fontWeight.bold,  // --pagination-base-font-weight
    gap: s.layout.gap.lg,                    // --pagination-base-gap (1.5rem)
    buttonSize: s.controlSize.md,            // --pagination-base-button-size (2.75rem)
    radius: s.radius.md,                     // --pagination-base-radius
    iconSize: s.iconSizes.lg,                // --pagination-base-icon-size
  },
  };
}
export const paginationTokens = createPaginationTokens(SEMANTIC);